'use strict';

var icon = require('../../../../../../../../../../_virtual/icon.cjs');
var accentColors = require('../../base/accentColors.cjs');

var hasRequiredIcon;

function requireIcon () {
	if (hasRequiredIcon) return icon.__exports;
	hasRequiredIcon = 1;

	var accentColors$1 = accentColors.__require();

	var ICON_BASE_COLORS = /*#__PURE__*/ function(ICON_BASE_COLORS) {
	    ICON_BASE_COLORS["system"] = "system";
	    ICON_BASE_COLORS["primary"] = "primary";
	    ICON_BASE_COLORS["success"] = "success";
	    ICON_BASE_COLORS["info"] = "info";
	    ICON_BASE_COLORS["warning"] = "warning";
	    ICON_BASE_COLORS["danger"] = "danger";
	    ICON_BASE_COLORS["highlight"] = "highlight";
	    return ICON_BASE_COLORS;
	}({});
	const ICON_COLORS = {
	    ...ICON_BASE_COLORS,
	    ...accentColors$1.AVIARY_ACCENTS
	};

	icon.__exports.ICON_BASE_COLORS = ICON_BASE_COLORS;
	icon.__exports.ICON_COLORS = ICON_COLORS;
	
	return icon.__exports;
}

exports.__require = requireIcon;
//# sourceMappingURL=icon.cjs.map
